import { Component, OnInit, Inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
export interface DialogData {
  availabilityType: 'availability' | 'vehicles' | 'exceptions';
  itemName?: string;
}
@Component({
  selector: 'app-confirm-change',
  templateUrl: './confirm-change-availability.component.html',
  styleUrls: ['./confirm-change-availability.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class ConfirmChangeAvailabilityComponent implements OnInit {
  availabilityType = signal<'availability' | 'vehicles' | 'exceptions'>('availability');
  itemName = signal<string>('');
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit() {
    this.availabilityType.set(
      this.data.availabilityType ? this.data.availabilityType : 'availability',
    );
    this.itemName.set(this.data.itemName || '');
  }
}
